import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import GlobalHelper from "../../GlobalHelper.jsx";
import Tabs from "../tabs.component";

class InvoicesTabs extends Component {

    constructor(props, context) {
        super(props, context)
    }

    getTabs() {
        let tabs = [
            {
                name: <FormattedMessage
                    id="menu.tabs.invoices.invoices"
                    defaultMessage="Invoices"
                />,
                link: '/invoices/listing',
            },
            {
                name: <FormattedMessage
                    id="menu.tabs.invoices.returns"
                    defaultMessage="Returns"
                />,
                link: '/returns/listing',
            },
            {
                name: <FormattedMessage
                    id="menu.tabs.invoices.credit_memos"
                    defaultMessage="Credit memos"
                />,
                link: '/credit-memos/listing',
            },
            {
                name: <FormattedMessage
                    id="menu.tabs.invoices.ageing_report"
                    defaultMessage="Ageing report"
                />,
                link: '/invoices/ageing-report',
            }
        ]
        if (AppContext.hasFeatureIntegration(Features.FeatureExternalOrderImport)) {
            tabs = tabs.concat({
                name: <FormattedMessage
                    id="menu.tabs.invoices.receipt"
                    defaultMessage="Receipts"
                />,
                link: '/receipts/listing',
            })
        }
        if (GlobalHelper.hasLightspeedIntegration()) {
            tabs = tabs.concat({
                name: <FormattedMessage
                    id="menu.tabs.invoices.lightspeed_sales"
                    defaultMessage="Lightspeed Sales"
                />,
                link: '/sales/listing',
            })
        }


        return tabs
    }

    render() {
        return (
            <Tabs value={this.getTabs()} />
        );
    }
}

export default InvoicesTabs


// WEBPACK FOOTER //
// ./src/common/layout/tabs/invoices.component.jsx